module.exports = __webpack_public_path__ + "static/media/fd_text_logo.0c54de4f.png";